const apiBaseUrl = "https://www.api.homeai.se";
// const apiBaseUrl = "http://localhost:8000";

export default apiBaseUrl;
